import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { ApiService } from '../API/api.service';

@Injectable({
  providedIn: 'root'
})
export class SOService {

  constructor(public apiService: ApiService) { }

  private messageSource = new BehaviorSubject({});
  currentEditSO = this.messageSource.asObservable();

  private productForMLC_Behavior = new BehaviorSubject({})
  productForMLC = this.productForMLC_Behavior.asObservable();

  private set_DO_Detail = new BehaviorSubject({})
  get_DO_Details = this.set_DO_Detail.asObservable();

  private product_detail = new BehaviorSubject({})
  get_product_detail = this.product_detail.asObservable();

  private editPackSlip = new BehaviorSubject({});
  currentEditPackSlips = this.editPackSlip.asObservable();

  changeEditPackSlips(data: any) {
    console.log(data)
    this.editPackSlip.next(data)
  }

  changeEditSO(data: any) {
    this.messageSource.next(data)
  }

  addProductForMLC(data: any) {
    this.productForMLC_Behavior.next(data)
  }

  setDODetail(data: any) {
    this.set_DO_Detail.next(data)
  }
  productDetail(data: any) {
    this.product_detail.next(data)
  }
  getAllSOs(body: any): Observable<any> {
    return this.apiService.post('salesorders/getAllSalesOrders', body)
  }

  getSOById(body: any): Observable<any> {
    return this.apiService.post('salesorders/getSOById', body)
  }

  addSO(body: any): Observable<any> {
    return this.apiService.post('salesorders/createSO', body);
  }

  editSO(body: any): Observable<any> {
    return this.apiService.post('salesorders/updateSO', body);
  }

  getSOCode(body: any): Observable<any> {
    return this.apiService.post('salesorders/beforeNewCreation', body);
  }

  inActivateSO(body: any, param: any): Observable<any> {
    return this.apiService.put('salesorders/inActivateSO', param, body);
  }
  closeSO(body: any, param: any): Observable<any> {
    return this.apiService.put('salesorders/closeSO', param, body);
  }
  getForcastSales(body: any): Observable<any> {
    return this.apiService.post('forcastsales/getAllForcastSales', body);
  }
  addForcastSales(body: any): Observable<any> {
    return this.apiService.post('forcastsales/addForcastSales', body);
  }
  editForcastSales(body: any): Observable<any> {
    return this.apiService.post('forcastsales/editForcastSales', body);
  }
  //Dispatch orders
  addDispatchOrder(body: any): Observable<any> {
    return this.apiService.post('', body);
  }
  getDONumber(body: any): Observable<any> {
    return this.apiService.post('do/beforeDOCreation', body);
  }
  addDO(body: any): Observable<any> {
    return this.apiService.post('do/createDO', body);
  }
  getAllDOs(body: any): Observable<any> {
    return this.apiService.post('do/getDOs', body);
  }
  getDOsByPS(body: any): Observable<any> {
    return this.apiService.post('do/getDOByPS', body);
  }
  getDosByFormulaId(body: any): Observable<any> {
    return this.apiService.post('do/getDosByFormulaId', body);
  }
  InActivatePs(body: any): Observable<any> {
    return this.apiService.post('ps/inActivatePS', body);
  }
  getDOdetails(body: any): Observable<any> {
    return this.apiService.post('', body);
  }
  getAllPackslips(body: any): Observable<any> {
    return this.apiService.post('ps/getPSs', body);
  }
  addPackslips(body: any): Observable<any> {
    return this.apiService.post('ps/createPS', body);
  }
  editPackslips(body: any): Observable<any> {
    return this.apiService.post('ps/editPackslips', body);
  }
  // S206 P414 Sheet 3
  getSheet3(body: any): Observable<any> {
    return this.apiService.post('ps/getSheet3', body);
  }
  getSlip(body: any): Observable<any> {
    return this.apiService.post('ps/getSlip', body);
  }
  // S207 P414 Sheet 3: bulk Ship (backend 16bafb7)
  shipSlips(body: any): Observable<any> {
    return this.apiService.post('ps/shipSlips', body);
  }
  getRpsbasedOnMonth(body: any): Observable<any> {
    return this.apiService.post('rp/getRPsBasedOnMonth', body);
  }
  getPsByDoId(body: any): Observable<any> {
    return this.apiService.post('ps/getPSByDoId', body);
  }
  getSOsByCustomerId(params:any): Observable<any> {
    return this.apiService.get(`salesorders/getSOsByCustomerId/${params}`);
  }
  cancelDo(body:any):Observable<any> {
    return this.apiService.post('do/cancelDo', body);
  }
  // S205b P414 Sheets 1-2 (backend b5573dc)
  createDOs(body: any): Observable<any> {
    return this.apiService.post('do/createDOs', body);
  }
  getBoard(body: any): Observable<any> {
    return this.apiService.post('do/getBoard', body);
  }
  saveBoard(body: any): Observable<any> {
    return this.apiService.post('do/saveBoard', body);
  }
  createPackingSlips(body: any): Observable<any> {
    return this.apiService.post('do/createPackingSlips', body);
  }
  // S222 P464: the Sheet 2 cross - the whole order back to 1 · Sales Orders.
  returnOrder(body: any): Observable<any> {
    return this.apiService.post('do/returnOrder', body);
  }
  // S208: open a packing-slip document (stored as '<file>|<name>'). The tab is opened at the
  // click - one opened after the reply is blocked as a pop-up - and then given the file.
  // PDFs and pictures show in the tab; other files download under their own name.
  // The server reads the caller's own company folder (isAuth), so no other company's file.
  openSlipDoc(entry: any, companyId: any, onError: (e: any) => void) {
    const s = String(entry || ''); const i = s.indexOf('|');
    const fd = i >= 0 ? s.slice(0, i) : s; const name = i >= 0 ? s.slice(i + 1) : s;
    const ext = (fd.split('.').pop() || '').toLowerCase();
    const types: any = { pdf: 'application/pdf', png: 'image/png', jpg: 'image/jpeg', jpeg: 'image/jpeg', gif: 'image/gif', webp: 'image/webp' };
    const type = types[ext];
    const w = type ? window.open('', '_blank') : null;
    this.apiService.post('file/downloadFile', { company_id: companyId, module_name: 'PackingSlip', file_id: fd }).subscribe((r: any) => {
      const url = URL.createObjectURL(new Blob([new Uint8Array((r && r.data) || [])], { type: type || 'application/octet-stream' }));
      if (w) { w.location.href = url; return; }
      const a = document.createElement('a'); a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
    }, (e: any) => { if (w) { w.close(); } onError(e); });
  }

}
